import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentsState, ShipmentsStore } from './shipments.store';
import { OrderFaceComponent } from '../../order-face/order-face.component';

@Component({
  selector: 'shipments-page',
  templateUrl: './shipments.page.html',
  styleUrl: './shipments.page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, RouterLink, OrderFaceComponent]
})
export class ShipmentsPage implements OnInit, OnDestroy {
  readonly state$: Observable<ShipmentsState>;

  // the list's shadow while it loads (0128): five rows at the row's height
  readonly shadowRows = [0, 1, 2, 3, 4];

  constructor(
    private store: ShipmentsStore,
    private destroyRef: DestroyRef
  ) {
    this.state$ = this.store.state$;
  }

  ngOnInit(): void {
    this.store.init().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  ngOnDestroy(): void {
    this.store.destroy();
  }
}
